import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchContent, fetchProducts, fetchBranding, getImageUrl } from '../api/api';
import './Footer.css';

const DEFAULT = {
  logo: '/images/logo.png',
  address: 'Unit 6, Park Shopping Centre, Prussia Street, Dublin 7, D07K802, Ireland',
  email: 'sales@greenwheelsscooters.ie',
  phone: '087 100 2241',
  hours: '10:30am - 7:00pm, Mon - Sun',
  social: [
    { name: 'Facebook',  url: 'https://www.facebook.com/people/Green-Wheels-Scooters/61560716000756/' },
    { name: 'Instagram', url: 'https://www.instagram.com/greenwheelsscooters/' }
  ],
  badges: [
    { icon: '🚚', text: 'Deliveries Countrywide' },
    { icon: '📜', text: '1 year warranty' },
    { icon: '📞', text: 'Online Support' }
  ],
  support: [
    { name: 'Terms of Service',       path: '/support/tos' },
    { name: 'Warranty Policy',        path: '/support/warranty' },
    { name: 'Privacy Policy',         path: '/support/privacy' },
    { name: 'Return & Refund Policy', path: '/support/return-refund' },
    { name: 'Contact Us',             path: '/contact' }
  ],
  disclaimer: 'Electric scooters may be used freely on private property. For use on public roads, please check the regulations in your country and ensure you purchase an electric scooter that meets legal requirements. GREEN WHEELS SCOOTER LIMITED does not encourage riding electric scooters in ways that breach applicable laws.',
  copyright: `© ${new Date().getFullYear()} Green Wheels Scooters. All rights reserved.`
};

const LOGO_FALLBACK = '';

function SocialIcon({ name }) {
  if (name === 'Facebook') return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  );
  if (name === 'Instagram') return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  );
  if (name === 'TikTok') return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.88 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .56.04.82.11V9.4a6.33 6.33 0 00-.82-.05A6.34 6.34 0 003.15 15.7a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.44a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.87z"/></svg>
  );
  if (name === 'Twitter' || name === 'X') return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  );
  if (name === 'YouTube') return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  );
  return <span style={{ fontSize: 14 }}>{name[0]}</span>;
}

function FooterLink({ path, children }) {
  return path?.startsWith('http')
    ? <a href={path} target="_blank" rel="noopener noreferrer">{children}</a>
    : <Link to={path || '/'}>{children}</Link>;
}

function Footer() {
  const [f, setF] = useState(DEFAULT);
  const [logo, setLogo] = useState(LOGO_FALLBACK);
  const [productCols, setProductCols] = useState({});

  useEffect(() => {
    fetchContent('footer').then(data => {
      const legacyMap = {
        '/tos': '/support/tos',
        '/warranty-policy': '/support/warranty',
        '/privacy-policy': '/support/privacy',
        '/return-refund-policy': '/support/return-refund',
      };
      const remapped = {
        ...data,
        support: (data.support?.length ? data.support : DEFAULT.support).map(l => ({
          ...l,
          path: legacyMap[l.path] || l.path,
        })),
      };
      setF({ ...DEFAULT, ...remapped });
    }).catch(() => {});
    fetchBranding().then(b => { if (b.logo) setLogo(getImageUrl(b.logo)); }).catch(() => {});
    fetchProducts().then(products => {
      const groups = { 'electric-scooters': [], 'electric-bikes': [] };
      products.forEach(p => {
        if (groups[p.category]) {
          const name = p.name.replace(/\s*\(\d{4}\)/, '').trim();
          groups[p.category].push({ name, path: `/products/${p.category}/${p.model}`, price: p.price || 0 });
        }
      });
      Object.keys(groups).forEach(k => groups[k].sort((a, b) => a.price - b.price));
      setProductCols(groups);
    }).catch(() => {});
  }, []);

  return (
    <footer className="footer">

      {/* Badges bar */}
      <div className="footer-badges">
        <div className="container">
          <div className="footer-badges-row">
            {((f.badges?.length ? f.badges : DEFAULT.badges) || []).map((b, i) => (
              <div key={i} className="footer-badge">
                <span className="footer-badge-icon">{b.icon}</span>
                <span>{b.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer columns */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-cols">

            {/* Col 1 — Logo + contact + social */}
            <div className="footer-col footer-col--brand">
              <div className="footer-logo">
                <Link to="/">
                  <img
                    src={logo}
                    alt="Green Wheels Scooters"
                    onError={e => { e.target.src = LOGO_FALLBACK; }}
                  />
                </Link>
              </div>
              <ul className="footer-info-list">
                <li><strong>Address:</strong> {f.address || DEFAULT.address}</li>
                <li><strong>E-mail:</strong> <a href={`mailto:${f.email || DEFAULT.email}`}>{f.email || DEFAULT.email}</a></li>
                <li><strong>Phone:</strong> <a href={`tel:${(f.phone || DEFAULT.phone).replace(/\s/g,'')}`}>{f.phone || DEFAULT.phone}</a></li>
                <li style={{ flexDirection: 'column', alignItems: 'flex-start' }}><strong>Hours:</strong><span style={{ whiteSpace: 'pre-line' }}>{f.hours || DEFAULT.hours}</span></li>
              </ul>
              <div className="footer-social">
                {(f.social || DEFAULT.social).map((s, i) => (
                  <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="footer-social-link" title={s.name}>
                    <SocialIcon name={s.name} />
                  </a>
                ))}
              </div>
            </div>

            {/* Col 2 — Support */}
            <div className="footer-col">
              <h4 className="footer-col-title">Support</h4>
              <ul className="footer-links">
                {(f.support || DEFAULT.support).map((l, i) => (
                  <li key={i}><FooterLink path={l.path}>{l.name}</FooterLink></li>
                ))}
              </ul>
            </div>

            {/* Dynamic product category columns */}
            {Object.entries(productCols).map(([category, items]) => (
              <div key={category} className="footer-col">
                <h4 className="footer-col-title">{category.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</h4>
                <ul className="footer-links">
                  {items.map((l, i) => (
                    <li key={i}><FooterLink path={l.path}>{l.name}</FooterLink></li>
                  ))}
                </ul>
              </div>
            ))}

          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="footer-disclaimer">
        <div className="container">
          <p>
            {(f.disclaimer || DEFAULT.disclaimer).replace('GREEN WHEELS SCOOTER LIMITED', '').split('').length > 0 &&
              <>{(f.disclaimer || DEFAULT.disclaimer).split('GREEN WHEELS SCOOTER LIMITED')[0]}
              <span className="brand-highlight">GREEN WHEELS SCOOTER LIMITED</span>
              {(f.disclaimer || DEFAULT.disclaimer).split('GREEN WHEELS SCOOTER LIMITED')[1]}</>
            }
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <div className="container">
          <p>{f.copyright || DEFAULT.copyright}</p>
        </div>
      </div>

    </footer>
  );
}

export default Footer;
